module.exports = __webpack_public_path__ + "media/images/lb/845-c7fd13cc9cbeb236bc901412f3037826.svg";